import colors from "./colors";

const COMMON = Object.freeze({
    blacklisted: colors.red,
    buttonBackground: colors.transparent,
    error: colors.red_with_opacity_50,
    negative: colors.red,
    positive: colors.blue_light,
    primary: colors.primary,
    quaternary: colors.quaternary,
    secondary: colors.secondary,
    shieldActive: colors.shieldActive,
    shieldInactive: colors.red,
    success: colors.secondary,
    tertiary: colors.tertiary,
    textActive: colors.primary,
    textInactive: colors.gray_medium,
    whitelisted: colors.secondary,
});

const DARK = Object.freeze({
    ...COMMON,
    appBackground: "#1F1F1F",
    border: colors.gray_medium,
    buttonBackgroundHover: colors.gray_semi_dark,
    disabled: colors.gray_medium,
    inputBackground: colors.gray_dark,
    navbarBackground: "#161616",
    overlay: colors.black_with_opacity_85,
    shadow: colors.primary,
    sidebarBackground: "#161616",
    textNeutral: colors.white,
});

const LIGHT = Object.freeze({
    ...COMMON,
    appBackground: colors.white,
    border: colors.gray_light,
    buttonBackgroundHover: colors.gray_light,
    disabled: colors.gray_very_medium,
    inputBackground: colors.gray_very_light,
    navbarBackground: colors.quaternary,
    overlay: colors.white_with_opacity_high,
    shadow: colors.gray_light,
    sidebarBackground: colors.gray_very_light,
    textNeutral: colors.black,
});

const THEME = {
    DARK,
    LIGHT,
};

export default THEME;
